import { compoundKey } from "@supply25/database/key";
import * as v from "valibot";

export const TenderPackageStatus = {
  DRAFT: "DRAFT",
  ACTIVE: "ACTIVE",
  REVIEW: "REVIEW",
  AWARDED: "AWARDED",
  CANCELLED: "CANCELLED",
  COMPLETE: "COMPLETE", // This status is TBC
  ARCHIVE: "ARCHIVE",
} as const;

export const ItemType = {
  TENDER_PACKAGE: "TENDER_PACKAGE",
  VIEWED: "VIEWED",
  CONTRACT: "CONTRACT",
  CONTRACT_LINK: "CONTRACT_LINK",
  REASSESSMENT: "REASSESSMENT",
} as const;

// An awarded supplier: its workspace, and whoever submitted its assessments,
// who become its team on the contract. Packages awarded before submitters
// were recorded carry none
export const SupplierSchema = v.object({
  organisationId: v.string(),
  workspaceId: v.string(),
  submitterIds: v.exactOptional(v.array(v.string())),
});

export const TenderPackageSchema = v.pipe(
  v.object({
    pk: compoundKey("ORGANISATION", "WORKSPACE"),
    sk: compoundKey("TENDER_PACKAGE"),
    type: v.literal(ItemType.TENDER_PACKAGE),
    activatedDate: v.exactOptional(v.string()),
    allowImprovementPlan: v.exactOptional(v.boolean()),
    authorId: v.string(),
    contactEmail: v.exactOptional(v.string()),
    contactName: v.exactOptional(v.string()),
    createdDate: v.string(),
    description: v.exactOptional(v.string()),
    id: v.string(),
    lastUpdated: v.exactOptional(v.string()),
    name: v.string(),
    referenceId: v.exactOptional(v.string()),
    submissionDeadline: v.exactOptional(v.string()),
    submissionDeadlineExecutionArn: v.exactOptional(v.string()),
    tenderPackageStatus: v.enum(TenderPackageStatus),
    suppliers: v.exactOptional(v.array(SupplierSchema)),
    contractId: v.exactOptional(v.string()),
  }),
  v.transform(({ pk, sk, ...rest }) => ({
    ...rest,
    organisationId: pk.ORGANISATION,
    workspaceId: pk.WORKSPACE,
  })),
);

export type TenderPackage = v.InferOutput<typeof TenderPackageSchema>;
